'use client';

import React from 'react';
import styles from './ServiceGrid.module.scss';

export interface ServiceItem {
  icon: string;
  title: string;
  description: string;
  features: string[];
}

interface ServiceGridProps {
  title: string;
  services: ServiceItem[];
  columns?: 2 | 3 | 4;
  className?: string;
}

export function ServiceGrid({
  title,
  services,
  columns = 2,
  className
}: ServiceGridProps) {
  return (
    <section className={`${styles.services} ${className || ''}`}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <div 
        className={`${styles.serviceGrid} ${styles[`columns${columns}`]}`}
      >
        {services.map((service, index) => (
          <div key={index} className={styles.serviceCard}>
            <div className={styles.serviceIcon}>{service.icon}</div>
            <h3 className={styles.serviceTitle}>{service.title}</h3>
            <p className={styles.serviceDescription}>{service.description}</p>
            <ul className={styles.serviceFeatures}>
              {service.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServiceGrid;